<h5 class="title">{{applicationType?.toLowerCase()?.replace('_', ' ')}} Application Attachments</h5>
<ng-container *ngFor="let document of applicationDocuments; let i = index">
    <button type="button" color="primary" mat-raised-button
            class="attachment-view"
            (click)="viewAttachment(document)">
        <i class="material-icons">attach_file</i>
        View [{{document?.attachmentType?.name}}]
    </button>
</ng-container>
